var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMultipleFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8332 15.8334H5.6665C5.20817 15.8334 4.81581 15.6702 4.48942 15.3438C4.16303 15.0174 3.99984 14.625 3.99984 14.1667V2.50004C3.99984 2.04171 4.16303 1.64935 4.48942 1.32296C4.81581 0.996568 5.20817 0.833374 5.6665 0.833374H11.4998L16.4998 5.83337V14.1667C16.4998 14.625 16.3366 15.0174 16.0103 15.3438C15.6839 15.6702 15.2915 15.8334 14.8332 15.8334ZM10.6665 6.66671V2.50004H5.6665V14.1667H14.8332V6.66671H10.6665ZM2.33317 19.1667C1.87484 19.1667 1.48248 19.0035 1.15609 18.6771C0.829698 18.3507 0.666504 17.9584 0.666504 17.5V5.83337H2.33317V17.5H11.4998V19.1667H2.33317Z",
    fill: "#00A0F3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMultipleFiles);
export default __webpack_public_path__ + "static/media/IconMultipleFiles.44917f47.svg";
export { ForwardRef as ReactComponent };